import { updateProfileNotificationSettings } from '../../domains/profile/api';
import { JSError } from './utils';

export const mutateProfileNotificationSettings = async ({
  userId,
  receiveAnalysisEmails,
  receiveFeedbackEmails,
}: {
  userId: number;
  receiveAnalysisEmails: boolean;
  receiveFeedbackEmails: boolean;
}): Promise<void> => {
  const response = await updateProfileNotificationSettings(userId, {
    receiveAnalysisEmails,
    receiveFeedbackEmails,
  });

  if (response.data.success) {
    return Promise.resolve();
  }

  return Promise.reject(
    new JSError(
      'Error updating profile notification settings! Api responded successfully but returned success as false.',
    ),
  );
};
